export const FILTER_UPDATE = "logs::filter::update";
export const LOAD_START = "logs::load::start";
export const LOAD_COMPLETE = "logs::load::complete";
